import { render, staticRenderFns } from "./PartnerMap.vue?vue&type=template&id=1b85fb9f&scoped=true&"
import script from "./PartnerMap.vue?vue&type=script&lang=ts&"
export * from "./PartnerMap.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerMap.vue?vue&type=style&index=0&id=1b85fb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85fb9f",
  null
  
)

export default component.exports